const SV = require('server-vars');

module.exports = function isPageType(pageTypes) {
    const pageType = SV.get('settings.pageType');
    return pageTypes.indexOf(pageType) > -1;
};



// WEBPACK FOOTER //
// ./src/utils/isPageType.js